import * as React from 'react'
import type { BracketTheme, ConnectorLine } from './types'

type ConnectorLayerProps = {
  color?: string | null
  connectors: ConnectorLine[]
  height: number
  theme: BracketTheme
  width: number
}

export const ConnectorLayer = React.memo(function ConnectorLayer({
  color,
  connectors,
  height,
  theme,
  width,
}: ConnectorLayerProps) {
  return (
    <svg
      className="pointer-events-none absolute left-0 top-0"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      aria-hidden
    >
      {connectors.map((line, index) => (
        <path
          key={index}
          d={line.d}
          stroke={color ?? 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="miter"
          className={theme.connector}
        />
      ))}
    </svg>
  )
})
